(() => {
  let sectionId = '';
  let customizerData = null;
  let currentStepIndex = 0;
  let selections = {};

  /** Plain text for labels (metaobject values may contain HTML snippets). */
  function displayChoiceTitle(raw) {
    if (raw == null) return '';
    let s = String(raw).replace(/<[^>]*>/g, '');
    s = s.replace(/\s+/g, ' ').trim();
    return s;
  }

  function escapeHtml(str) {
    if (str == null) return '';
    const div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  /** Figma selector icons (inline SVG). */
  const LOCKET_SVG_PHOTO =
    '<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M31.7479 14.9912C31.7479 13.956 31.7472 13.2226 31.6941 12.652C31.6548 12.2306 31.5894 11.9333 31.4923 11.6995L31.3847 11.4842C31.1941 11.1652 30.9371 10.8914 30.6315 10.6821L30.4969 10.5965C30.232 10.4383 29.8917 10.3395 29.3304 10.2871C28.7597 10.234 28.0256 10.2333 26.99 10.2333H25.9702L25.6938 10.2309C24.612 10.1898 23.6018 9.69207 22.9107 8.86747L22.7775 8.6975L22.6185 8.47128L22.4864 8.28419C22.0801 7.73991 21.4776 7.38219 20.8136 7.2815L20.5263 7.2546C20.4804 7.25286 20.4293 7.25216 20.2964 7.25216H15.7036L15.4749 7.2546C14.7961 7.28035 14.1591 7.57315 13.6994 8.06287L13.5136 8.28419L13.3827 8.47128L13.2225 8.6975C12.575 9.56522 11.5926 10.1149 10.5214 10.2162L10.3062 10.2309C10.231 10.2337 10.153 10.2333 10.0298 10.2333H9.01003C7.97488 10.2333 7.24141 10.234 6.67083 10.2871C6.24952 10.3264 5.95211 10.3918 5.71827 10.4889L5.50306 10.5965C5.18376 10.7872 4.91028 11.0451 4.70091 11.351L4.61531 11.4842C4.45698 11.7493 4.35828 12.0903 4.30594 12.652C4.25282 13.2226 4.25214 13.956 4.25214 14.9912V22.597C4.25214 24.1202 4.25344 25.2 4.36342 26.0184C4.47103 26.8188 4.67209 27.2759 5.00416 27.608L5.135 27.7254C5.45569 27.9879 5.89219 28.1545 6.59257 28.2487C7.41088 28.3587 8.49078 28.36 10.0139 28.36H25.9861C27.5094 28.36 28.5891 28.3588 29.4074 28.2487C30.2075 28.1411 30.6638 27.9399 30.9958 27.608L31.1145 27.4771C31.377 27.1564 31.5424 26.7189 31.6366 26.0184C31.7466 25.2 31.7479 24.1202 31.7479 22.597V14.9912ZM33 22.597C33 24.0851 33.0016 25.2646 32.8777 26.1859C32.7672 27.0074 32.5494 27.6952 32.0927 28.2585L31.8811 28.4933C31.2777 29.0966 30.5128 29.3636 29.5737 29.4899C28.6526 29.6137 27.4738 29.6121 25.9861 29.6121H10.0139C8.52624 29.6121 7.34737 29.6137 6.42627 29.4899C5.60426 29.3793 4.91593 29.1608 4.35241 28.7036L4.11886 28.4933C3.51541 27.8898 3.24857 27.125 3.12228 26.1859C2.99842 25.2646 3 24.0851 3 22.597V14.9912C3 13.9797 2.99891 13.178 3.0587 12.5358C3.11938 11.8846 3.24676 11.334 3.54048 10.8423L3.66765 10.643C3.97905 10.1882 4.3863 9.80531 4.86109 9.52166L5.04818 9.41895C5.49172 9.19707 5.98483 9.09419 6.55466 9.0411C7.19679 8.98132 7.9985 8.98119 9.01003 8.98119H10.0298C10.1626 8.98119 10.2127 8.9817 10.2585 8.97996L10.5471 8.95184C11.2109 8.85101 11.8137 8.49345 12.2199 7.94915L12.3507 7.76206L12.5097 7.53585L12.6442 7.36588C13.3353 6.54141 14.3455 6.04349 15.4272 6.00246L15.7036 6.00002H20.2964C20.4193 6.00002 20.4978 5.99963 20.5728 6.00246L20.7892 6.01714C21.8602 6.11863 22.8429 6.66825 23.4903 7.53585L23.6493 7.76206L23.7801 7.94915L23.966 8.17047C24.4256 8.6604 25.0626 8.95419 25.7415 8.97996L25.9702 8.98119H26.99C28.0019 8.98119 28.8043 8.98126 29.4466 9.0411C30.0975 9.10179 30.6474 9.22815 31.1389 9.52166L31.3382 9.65005C31.7929 9.96142 32.1759 10.3676 32.4595 10.8423L32.5622 11.0294C32.7842 11.473 32.8882 11.9659 32.9413 12.5358C33.0011 13.178 33 13.9797 33 14.9912V22.597Z" fill="black"/><path d="M22.3936 18.7189C22.3936 16.2925 20.4265 14.3254 18.0001 14.3254C15.5737 14.3254 13.6066 16.2924 13.6066 18.7189C13.6067 21.1453 15.5737 23.1124 18.0001 23.1124C20.4265 23.1123 22.3936 21.1453 22.3936 18.7189ZM23.6458 18.7189C23.6457 21.8368 21.1181 24.3645 18.0001 24.3645C14.8822 24.3645 12.3545 21.8368 12.3545 18.7189C12.3545 15.6009 14.8822 13.0732 18.0001 13.0732C21.1181 13.0733 23.6458 15.6009 23.6458 18.7189Z" fill="black"/><path d="M25.3027 14.6119C25.3027 14.1078 25.7113 13.6992 26.2154 13.6992V13.6992C26.7194 13.6992 27.128 14.1078 27.128 14.6119V14.6119C27.128 15.1159 26.7194 15.5245 26.2154 15.5245V15.5245C25.7113 15.5245 25.3027 15.1159 25.3027 14.6119V14.6119Z" fill="black"/></svg>';
  const LOCKET_SVG_TEXT =
    '<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M18.6743 22.4001V11.6001M18.6743 11.6001H14.6576M18.6743 11.6001H22.3719M9.25759 29.3429H27.7719C29.4761 29.3429 30.8576 27.9614 30.8576 26.2572V7.74294C30.8576 6.03875 29.4761 4.65723 27.7719 4.65723H9.25759C7.5534 4.65723 6.17188 6.03875 6.17188 7.74294V26.2572C6.17188 27.9614 7.5534 29.3429 9.25759 29.3429Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const LOCKET_SVG_STYLE_CIRCLE =
    '<svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="37.5" cy="37.5" r="37.5" fill="#F0F0F0"/></svg>';

  function canonicalEngravingMainTitle(raw) {
    const t = displayChoiceTitle(raw).toLowerCase();
    if (t.includes('no photo') || t.includes('email later')) return displayChoiceTitle(raw);
    if (t.includes('monogram')) return 'Monogram';
    if (t.includes('text')) return 'Text';
    if (t.includes('gallery') || t === 'image' || (t.includes('photo') && !t.includes('no photo'))) return 'Image';
    return displayChoiceTitle(raw);
  }

  /** @param {'default'|'synthetic-text-root'|'style'} iconMode */
  function choiceIconSvgHtml(rawTitle, iconMode) {
    const mode = iconMode || 'default';
    if (mode === 'style') return LOCKET_SVG_STYLE_CIRCLE;
    if (mode === 'synthetic-text-root') return LOCKET_SVG_TEXT;
    const canon = canonicalEngravingMainTitle(rawTitle);
    if (canon === 'Image') return LOCKET_SVG_PHOTO;
    if (canon === 'Monogram' || canon === 'Text') return LOCKET_SVG_TEXT;
    return LOCKET_SVG_TEXT;
  }

  function stylePickerCardTitle(rawTitle) {
    const canon = canonicalEngravingMainTitle(rawTitle);
    if (canon === 'Text') return 'Add Message';
    if (canon === 'Monogram') return 'Add Monogram';
    return displayChoiceTitle(rawTitle);
  }

  function stylePickerCardDescription(rawTitle) {
    const canon = canonicalEngravingMainTitle(rawTitle);
    if (canon === 'Text') return 'Personalize with a name, date, or short message.';
    if (canon === 'Monogram') return 'Classic three-letter monogram for an elegant finish.';
    return '';
  }

  function rootPhotoCardTitle(rawTitle) {
    if (canonicalEngravingMainTitle(rawTitle) === 'Image') return 'Photo';
    return displayChoiceTitle(rawTitle);
  }

  function engravingSelectorDescription(rawTitle) {
    const canon = canonicalEngravingMainTitle(rawTitle);
    if (canon === 'Image') {
      return 'Most popular for a reason — laser engraving delivers vivid, lasting color.';
    }
    if (canon === 'Text' || canon === 'Monogram') {
      return 'Add monogrammed initials, names, or a special message to make it truly personal.';
    }
    const t = displayChoiceTitle(rawTitle).toLowerCase();
    if (t.includes('no photo') || t.includes('email later')) {
      return 'Continue without adding photos or engraving to this side.';
    }
    return '';
  }

  function formatSelectorMainPrice(priceStr) {
    const p = parseFloat(priceStr);
    if (!p || p <= 0) return '';
    const rounded = Math.abs(p - Math.round(p)) < 0.001 ? Math.round(p) : p;
    const num = typeof rounded === 'number' && rounded === Math.round(rounded) ? String(rounded) : p.toFixed(2);
    return `+$${num}`;
  }

  function getEngravingMainOptions(step) {
    if (!step.choices || !step.choices.length) return [];
    return step.choices.filter(
      (c) =>
        c.group_key &&
        (c.group_key.includes('_engraving_options') ||
          c.title === 'No Photo or Engraving' ||
          c.title === 'Send Photo By Email Later')
    );
  }

  /** Sub-choices for how a photo is inserted (must match metaobject group_key variants). */
  function getImageInsertMethodChoices(step) {
    if (!step.choices || !step.choices.length) return [];
    return step.choices.filter((c) => {
      const gk = (c.group_key || '').toLowerCase();
      return (
        gk.includes('image_inserting') ||
        gk.includes('inserting_method') ||
        gk.includes('photo_method') ||
        gk.includes('upload_method') ||
        (gk.includes('photo') && gk.includes('method'))
      );
    });
  }

  function getEngravingCardRows(step) {
    return getEngravingMainOptions(step)
      .map((choice, idx) => ({ choice, idx }))
      .filter(({ choice }) => !/^skip\b/i.test(displayChoiceTitle(choice.title).trim()));
  }

  function isTwoTierEngravingStep(step) {
    const cardRows = getEngravingCardRows(step);
    const photoIdxs = cardRows.filter(({ choice }) => canonicalEngravingMainTitle(choice.title) === 'Image');
    const textMonoIdxs = cardRows.filter(({ choice }) => {
      const c = canonicalEngravingMainTitle(choice.title);
      return c === 'Text' || c === 'Monogram';
    });
    return photoIdxs.length >= 1 && textMonoIdxs.length >= 1;
  }

  /** CSS font stack for monogram preview from Shopify sub-choice title */
  function monogramFontStackFromTitle(title) {
    const t = displayChoiceTitle(title).toLowerCase();
    if (t.includes('script') || t.includes('cursive')) return '"Brush Script MT", "Segoe Script", "Snell Roundhand", cursive';
    if (t.includes('deco') || t.includes('art') || t.includes('circle') || t.includes('round'))
      return '"Copperplate Gothic Bold", Copperplate, "Arial Narrow", serif';
    return 'Georgia, "Times New Roman", "Liberation Serif", serif';
  }

  function monogramPreviewClassForIndex(subIdx) {
    const classes = ['locket-mono-preview--deco', 'locket-mono-preview--serif', 'locket-mono-preview--script'];
    return classes[subIdx % classes.length];
  }
  
  // Get customizer data from JSON script tag
  function loadCustomizerData() {
    const dataScript = document.getElementById(`locket-customizer-data-${sectionId}`);
    if (!dataScript) return null;
    
    try {
      const raw = JSON.parse(dataScript.textContent);
      if (!raw.view_assets || typeof raw.view_assets !== 'object' || Array.isArray(raw.view_assets)) {
        raw.view_assets = {};
      }
      return raw;
    } catch (e) {
      console.error('Failed to parse customizer data:', e);
      return null;
    }
  }
  
  // Open customizer modal
  function openCustomizer() {
    customizerData = loadCustomizerData();
    
    if (!customizerData || !customizerData.steps || customizerData.steps.length === 0) {
      alert('No customization options available for this product.');
      return;
    }
    
    currentStepIndex = 0;
    selections = {};
    
    const modal = document.getElementById(`locket-customizer-modal-${sectionId}`);
    if (!modal) {
      alert('Error: Customizer modal not found');
      return;
    }
    
    modal.classList.add('active');
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';

    hideExitConfirm(sectionId);
    
    renderTabs();
    renderStep();
    updatePreviewImage();
    updateNavButtons();
  }

  function hideExitConfirm(sid) {
    const id = sid || sectionId;
    const el = document.getElementById(`locket-exit-confirm-${id}`);
    if (!el) return;
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
  }

  function showExitConfirm(sid) {
    const id = sid || sectionId;
    const el = document.getElementById(`locket-exit-confirm-${id}`);
    if (!el) return;
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
  }

  /** True if the shopper has moved past the entry state (step or selections). */
  function selectionHasProgress(val) {
    if (!val || typeof val !== 'object') return false;
    if (val.skip === true) return true;
    if (val.main !== undefined && val.main !== null) return true;
    if (val.choice) return true;
    if (val.engravingPhase) return true;
    if (val.sub !== undefined && val.sub !== null) return true;
    if (val.subChoice) return true;
    if (val.personalization && typeof val.personalization === 'object') {
      return Object.values(val.personalization).some((v) => v != null && String(v).trim() !== '');
    }
    return false;
  }

  function hasCustomizerProgress() {
    if (!customizerData || !customizerData.steps) return false;
    if (currentStepIndex > 0) return true;
    return Object.values(selections).some(selectionHasProgress);
  }

  function withSection(sid, fn) {
    const prev = sectionId;
    sectionId = sid;
    try {
      fn();
    } finally {
      sectionId = prev;
    }
  }

  /** Close modal immediately (no confirmation). */
  function forceCloseCustomizer() {
    hideExitConfirm(sectionId);
    const modal = document.getElementById(`locket-customizer-modal-${sectionId}`);
    if (!modal) return;

    modal.classList.remove('active');
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  /** Ask before closing when there is customization progress. */
  function requestCloseCustomizer() {
    const sid = sectionId;
    const exitEl = document.getElementById(`locket-exit-confirm-${sid}`);
    if (exitEl && !exitEl.hasAttribute('hidden')) {
      return;
    }
    if (hasCustomizerProgress()) {
      showExitConfirm(sid);
      return;
    }
    withSection(sid, forceCloseCustomizer);
  }
  
  // Render step tabs
  function renderTabs() {
    const tabsContainer = document.getElementById(`locket-tabs-${sectionId}`);
    if (!tabsContainer || !customizerData) return;
    const currentStep = customizerData.steps[currentStepIndex];
    const stepTitle = currentStep?.title || 'Customize';
    const stepNum = `${currentStepIndex + 1} / ${customizerData.steps.length}`;
    tabsContainer.innerHTML = `
      <div class="locket-step-head">
        <div class="locket-step-head-row">
          <button type="button" class="locket-step-back" id="locket-step-back-${sectionId}" ${currentStepIndex === 0 ? 'disabled' : ''} aria-label="Previous step">←</button>
          <span class="locket-step-head-title">
            <span class="locket-step-name">${escapeHtml(displayChoiceTitle(stepTitle))}</span>
            <span class="locket-step-num">${escapeHtml(stepNum)}</span>
          </span>
          <button type="button" class="locket-my-progress-btn" aria-label="Open progress drawer">
            <span class="locket-my-progress-text">MY PROGRESS</span>
            <span class="locket-my-progress-burger" aria-hidden="true"><span></span><span></span><span></span></span>
          </button>
        </div>
        <div class="locket-step-progress">
          <span class="locket-step-progress-bar" style="width:${((currentStepIndex + 1) / customizerData.steps.length) * 100}%"></span>
        </div>
      </div>
    `;
  }
  
  /** Prefer merged view_assets[view_thumb_key] (metafield overrides) over per-step preview_image. */
  /** Uses product.view_assets from metafield custom.product_view_assets (filled by Admin sync, not alt on storefront). */
  function resolveStepPreviewUrl(step) {
    if (!step) return '';
    const va = customizerData && customizerData.view_assets;
    const k = step.view_thumb_key;
    const fromMap = va && k && typeof va === 'object' ? String(va[k] || '').trim() : '';
    const fromStep = step.preview_image ? String(step.preview_image).trim() : '';
    const isHttp = (u) => u && u.includes('://');
    if (isHttp(fromMap)) return fromMap;
    if (isHttp(fromStep)) return fromStep;
    return fromMap || fromStep || '';
  }

  // Update preview image based on current step
  function updatePreviewImage() {
    const previewContainer = document.getElementById(`locket-preview-${sectionId}`);
    if (!previewContainer || !customizerData) return;
    
    const step = customizerData.steps[currentStepIndex];
    if (!step) return;
    
    const previewSrc = resolveStepPreviewUrl(step);
    
    // Clear existing content
    previewContainer.innerHTML = '';
    previewContainer.style.cssText = 'position: relative; display: flex; align-items: center; justify-content: center;';
    
    if (previewSrc && previewSrc !== '') {
      const imgWrapper = document.createElement('div');
      imgWrapper.style.cssText = 'position: relative; width: 300px; height: 300px;';
      
      const img = document.createElement('img');
      img.src = previewSrc;
      img.alt = `${step.title} Preview`;
      img.style.cssText = 'width: 300px; height: 300px; object-fit: contain; display: block;';
      img.onerror = () => {
        previewContainer.innerHTML = '<p style="color: #999; text-align: center;">Preview not available</p>';
      };
      
      imgWrapper.appendChild(img);
      
      // Add text overlay container
      const textOverlay = document.createElement('div');
      textOverlay.id = `text-overlay-${step.key}`;
      textOverlay.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; pointer-events: none;';
      imgWrapper.appendChild(textOverlay);
      
      previewContainer.appendChild(imgWrapper);
    } else {
      const placeholder = document.createElement('div');
      placeholder.style.cssText = 'display: flex; align-items: center; justify-content: center; height: 100%; color: #999;';
      placeholder.textContent = 'No preview available';
      previewContainer.appendChild(placeholder);
    }
  }
  
  // Update text overlay on preview image
  function updateTextOverlay(stepKey, text, isMonogram = false, fontStyle = 'Block') {
    const textOverlay = document.getElementById(`text-overlay-${stepKey}`);
    if (!textOverlay) return;
    
    if (!text || text.trim() === '') {
      textOverlay.innerHTML = '';
      return;
    }
    
    // Clear previous content
    textOverlay.innerHTML = '';
    
    // Create text element
    const textElement = document.createElement('div');
    textElement.textContent = text.trim();
    
    if (isMonogram) {
      const ff = monogramFontStackFromTitle(fontStyle);
      textElement.style.cssText = `
        font-size: clamp(64px, 18vw, 120px);
        font-weight: bold;
        color: #000000;
        text-align: center;
        line-height: 1;
        text-transform: uppercase;
        font-family: ${ff};
      `;
    } else {
      const ff =
        String(fontStyle).toLowerCase().includes('script') || String(fontStyle).toLowerCase().includes('cursive')
          ? '"Brush Script MT", "Segoe Script", cursive'
          : 'Arial, Helvetica, sans-serif';
      textElement.style.cssText = `
        font-size: 24px;
        color: #333;
        text-align: center;
        padding: 10px;
        max-width: 200px;
        word-wrap: break-word;
        line-height: 1.3;
        font-family: ${ff};
      `;
    }
    
    textOverlay.appendChild(textElement);
  }
  
  // Update image overlay on preview image
  function updateImageOverlay(stepKey, imageFile, blackAndWhite = false) {
    const textOverlay = document.getElementById(`text-overlay-${stepKey}`);
    if (!textOverlay) return;

    if (!imageFile) {
      textOverlay.innerHTML = '';
      return;
    }

    // Clear previous content
    textOverlay.innerHTML = '';

    // Create file reader to read the uploaded image
    const reader = new FileReader();
    reader.onload = function(e) {
      const imgElement = document.createElement('img');
      imgElement.src = e.target.result;
      imgElement.style.cssText = `
        max-width: 200px;
        max-height: 200px;
        object-fit: contain;
        border-radius: 4px;
        filter: ${blackAndWhite ? 'grayscale(1)' : 'none'};
      `;
      textOverlay.appendChild(imgElement);
    };
    reader.readAsDataURL(imageFile);
  }

  /** Human-readable accepted file types from a setting's allowed_files (default JPG/PNG). */
  function photoAcceptHuman(setting) {
    const raw = (setting && setting.allowed_files ? String(setting.allowed_files) : '').trim();
    if (!raw) return 'JPG, PNG';
    return raw
      .split(/[\s,|]+/)
      .filter(Boolean)
      .map((x) => x.replace(/^\./, '').toUpperCase())
      .join(', ');
  }

  function photoAcceptAttr(setting) {
    const raw = (setting && setting.allowed_files ? String(setting.allowed_files) : '').trim();
    if (!raw) return 'image/jpeg,image/png';
    return raw
      .split(/[\s,|]+/)
      .filter(Boolean)
      .map((x) => (x.startsWith('.') ? x : '.' + x))
      .join(',');
  }

  const PHOTO_DID_YOU_KNOW =
    'Our designers will edit & crop your image to ensure a perfect fit. Specific request? Leave a note in the Design Notes.';
  const DESIGN_NOTE_MAX = 240;
  const PHOTO_PROOF_PRICE = 10;

  const LOCKET_SVG_BELL =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Zm7-5-1.5-1.6V10a5.5 5.5 0 0 0-4-5.3V4a1.5 1.5 0 0 0-3 0v.7A5.5 5.5 0 0 0 6.5 10v5.4L5 17a.75.75 0 0 0 .5 1.3h13A.75.75 0 0 0 19 17Z" fill="currentColor"/></svg>';

  function applyPhotoBWToThumb(container, bw) {
    const img = container && container.querySelector('.locket-photo-thumb__img');
    if (img) img.style.filter = bw ? 'grayscale(1)' : 'none';
  }

  /** Slide-up "Add design request" drawer. onApply() runs after the shopper applies. */
  function openDesignNoteDrawer(selected, onApply) {
    const host =
      document.querySelector(`#locket-customizer-modal-${sectionId} .locket-customizer-options`) || document.body;
    const existing = host.querySelector('.locket-note-drawer');
    if (existing) existing.remove();

    const drawer = document.createElement('div');
    drawer.className = 'locket-note-drawer';
    drawer.innerHTML = `
      <div class="locket-note-drawer__backdrop"></div>
      <div class="locket-note-drawer__sheet" role="dialog" aria-modal="true" aria-label="Add design request">
        <div class="locket-note-drawer__head">
          <h3 class="locket-note-drawer__title">Add design request</h3>
          <button type="button" class="locket-note-drawer__x" aria-label="Close">&times;</button>
        </div>
        <label class="locket-note-drawer__label" for="locket-note-text-${sectionId}">Design note</label>
        <textarea id="locket-note-text-${sectionId}" class="locket-note-drawer__textarea" maxlength="${DESIGN_NOTE_MAX}" rows="4" placeholder="e.g. Please center the faces and keep the background light."></textarea>
        <div class="locket-note-drawer__counter">0 / ${DESIGN_NOTE_MAX}</div>
        <label class="locket-note-drawer__proof">
          <input type="checkbox" class="locket-note-drawer__proof-input" />
          <span>Request proof (+$${PHOTO_PROOF_PRICE})</span>
        </label>
        <div class="locket-note-drawer__actions">
          <button type="button" class="locket-note-drawer__clear">Clear</button>
          <button type="button" class="locket-note-drawer__apply">Apply</button>
        </div>
      </div>
    `;
    host.appendChild(drawer);

    const ta = drawer.querySelector('.locket-note-drawer__textarea');
    const counter = drawer.querySelector('.locket-note-drawer__counter');
    const proof = drawer.querySelector('.locket-note-drawer__proof-input');
    ta.value = selected.designNote || '';
    counter.textContent = `${ta.value.length} / ${DESIGN_NOTE_MAX}`;
    proof.checked = !!selected.requestProof;
    ta.addEventListener('input', () => {
      counter.textContent = `${ta.value.length} / ${DESIGN_NOTE_MAX}`;
    });
    requestAnimationFrame(() => drawer.classList.add('is-open'));

    function close() {
      drawer.classList.remove('is-open');
      setTimeout(() => drawer.remove(), 250);
    }
    drawer.querySelector('.locket-note-drawer__x').addEventListener('click', close);
    drawer.querySelector('.locket-note-drawer__backdrop').addEventListener('click', close);
    drawer.querySelector('.locket-note-drawer__clear').addEventListener('click', () => {
      ta.value = '';
      counter.textContent = `0 / ${DESIGN_NOTE_MAX}`;
      proof.checked = false;
    });
    drawer.querySelector('.locket-note-drawer__apply').addEventListener('click', () => {
      selected.designNote = ta.value.trim();
      selected.requestProof = !!proof.checked;
      if (typeof onApply === 'function') onApply();
      if (typeof updateNavButtons === 'function') updateNavButtons();
      close();
    });
  }

  function selectionAllowsProceed(step, sel) {
    if (!step.choices || step.choices.length === 0) return true;
    if (!sel) return false;
    if (sel.skip === true) return true;
    if (sel.main === undefined) return false;
    const choice = sel.choice;
    if (!choice) return true;
    const canon = canonicalEngravingMainTitle(choice.title);
    const imageMethods = getImageInsertMethodChoices(step);
    if (canon === 'Image' && imageMethods.length > 0 && !sel.subChoice) return false;
    // §12: NEXT is gated on the photo actually being uploaded for photo-upload steps.
    if (canon === 'Image') {
      const hasImageFileSetting = (step.settings || []).some((s) => {
        const gk = (s.group_key || '').toLowerCase();
        const nm = (s.name || '').toLowerCase();
        return s.type === 'file' && (gk.includes('image') || nm.includes('image')) && !gk.includes('inserting') && !nm.includes('inserting');
      });
      if (hasImageFileSetting) {
        const hasUpload = sel.uploadedFiles && Object.keys(sel.uploadedFiles).some((k) => sel.uploadedFiles[k]);
        if (!hasUpload) return false;
      }
    }
    const textFontOptions = step.choices.filter((c) => c.group_key && c.group_key.includes('_engraving_text_font_style'));
    const monogramFontOptions = step.choices.filter((c) => c.group_key && c.group_key.includes('_engraving_monogram_font_style'));
    if (canon === 'Text' && textFontOptions.length > 0 && !sel.subChoice) return false;
    if (canon === 'Monogram' && monogramFontOptions.length > 0 && !sel.subChoice) return false;
    return true;
  }
  
  // Render current step content
  function renderStep() {
    const contentContainer = document.getElementById(`locket-step-content-${sectionId}`);
    if (!contentContainer || !customizerData) return;

    const step = customizerData.steps[currentStepIndex];
    if (!step) return;

    contentContainer.innerHTML = '';

    if (!step.choices || step.choices.length === 0) {
      const noOptions = document.createElement('p');
      noOptions.className = 'locket-step-empty';
      noOptions.textContent = 'No options available for this step.';
      contentContainer.appendChild(noOptions);
      return;
    }

    const mainOptions = getEngravingMainOptions(step);
    const imageMethodOptions = getImageInsertMethodChoices(step);
    const textFontOptions = step.choices.filter((c) => c.group_key && c.group_key.includes('_engraving_text_font_style'));
    const monogramFontOptions = step.choices.filter((c) => c.group_key && c.group_key.includes('_engraving_monogram_font_style'));

    function getRelevantSettings(mainChoiceTitle) {
      if (!step.settings || step.settings.length === 0) return [];
      return step.settings.filter((setting) => {
        const lowerGroupKey = (setting.group_key || '').toLowerCase();
        if (mainChoiceTitle === 'Text') return lowerGroupKey.includes('text') && !lowerGroupKey.includes('font_style');
        if (mainChoiceTitle === 'Monogram') return lowerGroupKey.includes('monogram') && !lowerGroupKey.includes('font_style');
        if (mainChoiceTitle === 'Image') return lowerGroupKey.includes('image') && !lowerGroupKey.includes('inserting_method');
        return false;
      });
    }

    function syncOverlay(mainChoiceTitle) {
      if (!selections[step.key]) return;
      const selected = selections[step.key];
      const fontStyle = selected.subChoice?.title || 'Block';
      const isMonogram = mainChoiceTitle === 'Monogram';
      let applied = false;

      if (selected.personalization) {
        Object.keys(selected.personalization).forEach((fieldName) => {
          const fieldNameLower = fieldName.toLowerCase();
          if ((fieldNameLower.includes('text') || fieldNameLower.includes('monogram')) && !fieldNameLower.includes('font')) {
            const textValue = selected.personalization[fieldName];
            if (textValue && textValue.trim() !== '') {
              updateTextOverlay(step.key, textValue, isMonogram, fontStyle);
              applied = true;
            }
          }
        });
      }

      if (!applied && selected.uploadedFiles) {
        Object.keys(selected.uploadedFiles).forEach((fieldName) => {
          const fieldNameLower = fieldName.toLowerCase();
          if (fieldNameLower.includes('image') && !fieldNameLower.includes('inserting')) {
            const file = selected.uploadedFiles[fieldName];
            if (file) {
              updateImageOverlay(step.key, file, !!selected.photoBW);
              applied = true;
            }
          }
        });
      }
      if (!applied) updateTextOverlay(step.key, '', false, 'Block');
    }

    function renderFields(panel, mainChoiceTitle) {
      const selected = selections[step.key];
      if (!selected) return;

      const old = panel.querySelector('.locket-inline-fields');
      if (old) old.remove();

      if (!['Text', 'Monogram', 'Image'].includes(mainChoiceTitle)) return;
      if ((mainChoiceTitle === 'Text' || mainChoiceTitle === 'Monogram') && !selected.subChoice) return;
      if (mainChoiceTitle === 'Image' && imageMethodOptions.length > 0 && !selected.subChoice) return;

      const relevantSettings = getRelevantSettings(mainChoiceTitle);
      if (relevantSettings.length === 0) return;

      const skipMonogramInitialsField =
        mainChoiceTitle === 'Monogram' && panel.querySelector('.locket-mono-initials-input');

      const fieldsWrap = document.createElement('div');
      fieldsWrap.className = 'locket-inline-fields';

      relevantSettings.forEach((setting) => {
        const fieldName = setting.name || 'Input';
        const fieldNameLower = fieldName.toLowerCase();

        if (
          skipMonogramInitialsField &&
          (setting.type === 'field' || setting.type === 'area') &&
          (fieldNameLower.includes('monogram') || fieldNameLower.includes('initial'))
        ) {
          return;
        }

        const row = document.createElement('div');
        row.className = 'locket-inline-field-row';

        const label = document.createElement('label');
        label.className = 'locket-inline-field-label';
        label.textContent = fieldName;
        row.appendChild(label);

        if (setting.type === 'field' || setting.type === 'area') {
          const input = setting.type === 'area' ? document.createElement('textarea') : document.createElement('input');
          if (setting.type !== 'area') input.type = 'text';
          if (setting.type === 'area') input.rows = 4;
          input.className = 'locket-inline-field-input';
          input.placeholder = `Enter your ${fieldName.toLowerCase()}`;

          const maxChars = parseInt(setting.max_characters, 10) || 0;
          const isTextInput = fieldNameLower.includes('text') && !fieldNameLower.includes('font');
          const isMonogramInput = fieldNameLower.includes('monogram') && !fieldNameLower.includes('font');

          if (maxChars > 0) input.maxLength = maxChars;

          const counter = document.createElement('div');
          counter.className = 'locket-inline-field-counter';
          if (maxChars > 0) counter.textContent = `0 / ${maxChars}`;

          input.addEventListener('input', (e) => {
            const value = e.target.value || '';
            if (!selected.personalization) selected.personalization = {};
            selected.personalization[fieldName] = value;
            if (maxChars > 0) counter.textContent = `${value.length} / ${maxChars}`;
            if (isTextInput || isMonogramInput) {
              const fontStyle = selected.subChoice?.title || 'Block';
              updateTextOverlay(step.key, value, isMonogramInput, fontStyle);
            }
          });

          const saved = selected.personalization?.[fieldName];
          if (saved) {
            input.value = saved;
            if (maxChars > 0) counter.textContent = `${saved.length} / ${maxChars}`;
          }

          row.appendChild(input);
          if (maxChars > 0) row.appendChild(counter);
        } else if (setting.type === 'file') {
          const isImageUpload = fieldNameLower.includes('image') && !fieldNameLower.includes('inserting');
          if (mainChoiceTitle === 'Image' && isImageUpload) {
            row.appendChild(buildPhotoUploadUI(setting, fieldName, selected));
          } else {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = photoAcceptAttr(setting);
            input.className = 'locket-inline-field-input';
            input.addEventListener('change', (e) => {
              const file = e.target.files && e.target.files[0];
              if (!file) return;
              if (!selected.personalization) selected.personalization = {};
              if (!selected.uploadedFiles) selected.uploadedFiles = {};
              selected.personalization[fieldName] = file.name;
              selected.uploadedFiles[fieldName] = file;
              if (isImageUpload) updateImageOverlay(step.key, file, !!selected.photoBW);
            });
            row.appendChild(input);
          }
        }

        fieldsWrap.appendChild(row);
      });

      panel.appendChild(fieldsWrap);
    }

    /** §12 photo flow: drop zone → thumbnail + edit toolbar (Change / B&W / Reset) + "Add a design note". */
    function buildPhotoUploadUI(setting, fieldName, selected) {
      const root = document.createElement('div');
      root.className = 'locket-photo-ui';

      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'file';
      hiddenInput.accept = photoAcceptAttr(setting);
      hiddenInput.className = 'locket-photo-file-input';
      hiddenInput.hidden = true;
      root.appendChild(hiddenInput);

      // --- Drop zone (shown when no file yet) ---
      const dropZone = document.createElement('div');
      dropZone.className = 'locket-photo-drop';
      dropZone.setAttribute('role', 'button');
      dropZone.setAttribute('tabindex', '0');
      dropZone.setAttribute('aria-label', `Upload photo for ${displayChoiceTitle(setting.name || fieldName)}`);
      dropZone.innerHTML = `
        <span class="locket-photo-drop__icon" aria-hidden="true">${LOCKET_SVG_PHOTO}</span>
        <span class="locket-photo-drop__main">Drag &amp; Drop or <span class="locket-photo-drop__browse">Browse Your Device</span></span>
        <span class="locket-photo-drop__hint">${escapeHtml(photoAcceptHuman(setting))}</span>
      `;
      root.appendChild(dropZone);

      // --- Edit view (shown after a file is chosen) ---
      const editView = document.createElement('div');
      editView.className = 'locket-photo-edit';
      editView.innerHTML = `
        <div class="locket-photo-thumb"><img class="locket-photo-thumb__img" alt="Your uploaded photo" /></div>
        <div class="locket-photo-thumb__name"></div>
        <div class="locket-photo-tools">
          <button type="button" class="locket-photo-tool locket-photo-tool--change">Change</button>
          <button type="button" class="locket-photo-tool locket-photo-tool--bw">B&amp;W</button>
          <button type="button" class="locket-photo-tool locket-photo-tool--reset">Reset</button>
        </div>
        <button type="button" class="locket-photo-note-btn">Add a design note</button>
      `;
      root.appendChild(editView);

      // --- "Did You Know?" callout (always visible) ---
      const dyk = document.createElement('div');
      dyk.className = 'locket-photo-dyk';
      dyk.innerHTML = `<span class="locket-photo-dyk__icon" aria-hidden="true">${LOCKET_SVG_BELL}</span><div class="locket-photo-dyk__body"><strong>Did You Know?</strong><p>${escapeHtml(PHOTO_DID_YOU_KNOW)}</p></div>`;
      root.appendChild(dyk);

      function currentFile() {
        return selected.uploadedFiles && selected.uploadedFiles[fieldName];
      }

      function refresh() {
        const file = currentFile();
        dropZone.style.display = file ? 'none' : '';
        editView.style.display = file ? '' : 'none';
        if (file) {
          const thumbImg = editView.querySelector('.locket-photo-thumb__img');
          const nameEl = editView.querySelector('.locket-photo-thumb__name');
          if (nameEl) nameEl.textContent = file.name || '';
          if (thumbImg) {
            const r = new FileReader();
            r.onload = (ev) => { thumbImg.src = ev.target.result; };
            r.readAsDataURL(file);
          }
          applyPhotoBWToThumb(editView, !!selected.photoBW);
          const bwBtn = editView.querySelector('.locket-photo-tool--bw');
          if (bwBtn) bwBtn.classList.toggle('is-active', !!selected.photoBW);
          const noteBtn = editView.querySelector('.locket-photo-note-btn');
          if (noteBtn) noteBtn.textContent = selected.designNote && selected.designNote.trim() ? 'Edit note' : 'Add a design note';
        }
      }

      function setFile(file) {
        if (!file) return;
        if (!selected.personalization) selected.personalization = {};
        if (!selected.uploadedFiles) selected.uploadedFiles = {};
        selected.personalization[fieldName] = file.name;
        selected.uploadedFiles[fieldName] = file;
        updateImageOverlay(step.key, file, !!selected.photoBW);
        refresh();
        updateNavButtons();
      }

      hiddenInput.addEventListener('change', (e) => {
        const f = e.target.files && e.target.files[0];
        if (f) setFile(f);
        hiddenInput.value = '';
      });

      dropZone.addEventListener('click', () => hiddenInput.click());
      dropZone.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          hiddenInput.click();
        }
      });
      ['dragenter', 'dragover'].forEach((ev) =>
        dropZone.addEventListener(ev, (e) => {
          e.preventDefault();
          dropZone.classList.add('is-dragover');
        })
      );
      ['dragleave', 'dragend'].forEach((ev) =>
        dropZone.addEventListener(ev, () => dropZone.classList.remove('is-dragover'))
      );
      dropZone.addEventListener('drop', (e) => {
        e.preventDefault();
        dropZone.classList.remove('is-dragover');
        const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (f) setFile(f);
      });

      editView.querySelector('.locket-photo-tool--change').addEventListener('click', () => hiddenInput.click());
      editView.querySelector('.locket-photo-tool--bw').addEventListener('click', (e) => {
        selected.photoBW = !selected.photoBW;
        e.currentTarget.classList.toggle('is-active', !!selected.photoBW);
        applyPhotoBWToThumb(editView, !!selected.photoBW);
        updateImageOverlay(step.key, currentFile(), !!selected.photoBW);
      });
      editView.querySelector('.locket-photo-tool--reset').addEventListener('click', () => {
        selected.photoBW = false;
        editView.querySelector('.locket-photo-tool--bw').classList.remove('is-active');
        applyPhotoBWToThumb(editView, false);
        updateImageOverlay(step.key, currentFile(), false);
      });
      editView.querySelector('.locket-photo-note-btn').addEventListener('click', () => openDesignNoteDrawer(selected, refresh));

      refresh();
      return root;
    }

    function renderMonogramRichPanel(panel, subOptions, selected) {
      const wrap = document.createElement('div');
      wrap.className = 'locket-mono-panel';

      const nav = document.createElement('div');
      nav.className = 'locket-mono-panel__nav';
      const localBack = document.createElement('button');
      localBack.type = 'button';
      localBack.className = 'locket-mono-panel__back';
      localBack.setAttribute('aria-label', 'Back to engraving type');
      localBack.innerHTML = '<span class="locket-mono-panel__back-icon" aria-hidden="true">\u2190</span>';
      const headTitle = document.createElement('span');
      headTitle.className = 'locket-mono-panel__heading';
      headTitle.textContent = selected.subChoice
        ? `Monogramming ${displayChoiceTitle(selected.subChoice.title)}`
        : 'Monogramming';
      nav.appendChild(localBack);
      nav.appendChild(headTitle);
      localBack.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (isTwoTierEngravingStep(step)) {
          selections[step.key] = { engravingPhase: 'text-pick' };
        } else {
          delete selections[step.key];
        }
        updateTextOverlay(step.key, '', false, 'Block');
        renderStep();
        updateNavButtons();
      });
      wrap.appendChild(nav);

      const styleRow = document.createElement('div');
      styleRow.className = 'locket-mono-style-row';

      subOptions.forEach((subChoice, subIdx) => {
        const tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'locket-mono-style-tile';
        if (selected.sub === subIdx) tile.classList.add('is-selected');
        const prev = document.createElement('div');
        prev.className = `locket-mono-preview ${monogramPreviewClassForIndex(subIdx)}`;
        prev.setAttribute('aria-hidden', 'true');
        prev.textContent = 'ABC';
        prev.style.fontFamily = monogramFontStackFromTitle(subChoice.title);
        tile.appendChild(prev);
        tile.addEventListener('click', () => {
          selected.sub = subIdx;
          selected.subChoice = subChoice;
          renderStep();
          updateNavButtons();
        });
        styleRow.appendChild(tile);
      });
      wrap.appendChild(styleRow);

      const monoSettings = getRelevantSettings('Monogram');
      const initialsSetting =
        monoSettings.find(
          (s) =>
            (s.type === 'field' || s.type === 'area') &&
            (String(s.name || '')
              .toLowerCase()
              .includes('monogram') ||
              String(s.name || '')
                .toLowerCase()
                .includes('initial') ||
              String(s.group_key || '')
                .toLowerCase()
                .includes('monogram'))
        ) || monoSettings.find((s) => s.type === 'field' || s.type === 'area');

      if (initialsSetting && selected.subChoice) {
        const fieldName = initialsSetting.name || 'Initials';
        const maxChars = parseInt(initialsSetting.max_characters, 10) || 0;
        const inputWrap = document.createElement('div');
        inputWrap.className = 'locket-mono-field';
        const input =
          initialsSetting.type === 'area' ? document.createElement('textarea') : document.createElement('input');
        if (initialsSetting.type !== 'area') input.type = 'text';
        if (initialsSetting.type === 'area') input.rows = 3;
        input.className = 'locket-mono-initials-input';
        input.placeholder = 'Enter Initials';
        input.autocomplete = 'off';
        if (maxChars) input.maxLength = maxChars;
        const saved = selected.personalization?.[fieldName];
        if (saved) input.value = saved;
        input.addEventListener('input', () => {
          const value = input.value || '';
          if (!selected.personalization) selected.personalization = {};
          selected.personalization[fieldName] = value;
          updateTextOverlay(step.key, value, true, selected.subChoice?.title || '');
        });
        inputWrap.appendChild(input);
        wrap.appendChild(inputWrap);
      }

      const removeRow = document.createElement('div');
      removeRow.className = 'locket-mono-remove-row';
      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'locket-mono-remove';
      removeBtn.innerHTML =
        '<span class="locket-mono-remove__x" aria-hidden="true">\u2715</span><span>REMOVE</span>';
      removeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (selected.personalization) {
          getRelevantSettings('Monogram').forEach((s) => {
            const n = s.name;
            if (n && selected.personalization) delete selected.personalization[n];
          });
        }
        selected.sub = undefined;
        selected.subChoice = undefined;
        updateTextOverlay(step.key, '', true, '');
        renderStep();
        updateNavButtons();
      });
      removeRow.appendChild(removeBtn);
      wrap.appendChild(removeRow);

      panel.appendChild(wrap);
    }

    function renderImageMethodPanel(panel, subOptions, selected) {
      const wrap = document.createElement('div');
      wrap.className = 'locket-mono-panel locket-mono-panel--image-method';

      const nav = document.createElement('div');
      nav.className = 'locket-mono-panel__nav';
      const localBack = document.createElement('button');
      localBack.type = 'button';
      localBack.className = 'locket-mono-panel__back';
      localBack.setAttribute('aria-label', 'Back to engraving type');
      localBack.innerHTML = '<span class="locket-mono-panel__back-icon" aria-hidden="true">\u2190</span>';
      const headTitle = document.createElement('span');
      headTitle.className = 'locket-mono-panel__heading';
      headTitle.textContent = selected.subChoice
        ? `Photo: ${displayChoiceTitle(selected.subChoice.title)}`
        : 'Choose photo method';
      nav.appendChild(localBack);
      nav.appendChild(headTitle);
      localBack.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        selected.sub = undefined;
        selected.subChoice = undefined;
        if (selected.personalization) {
          getRelevantSettings('Image').forEach((s) => {
            const n = s.name;
            if (n && selected.personalization) delete selected.personalization[n];
          });
        }
        if (selected.uploadedFiles) {
          getRelevantSettings('Image').forEach((s) => {
            const n = s.name;
            if (n && selected.uploadedFiles) delete selected.uploadedFiles[n];
          });
        }
        updateImageOverlay(step.key, null);
        renderStep();
        updateNavButtons();
      });
      wrap.appendChild(nav);

      const styleRow = document.createElement('div');
      styleRow.className = 'locket-mono-style-row locket-mono-style-row--image-methods';

      subOptions.forEach((subChoice, subIdx) => {
        const tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'locket-mono-style-tile locket-mono-style-tile--image-method';
        if (selected.sub === subIdx) tile.classList.add('is-selected');
        const prev = document.createElement('div');
        prev.className = 'locket-mono-preview locket-mono-preview--image-method';
        prev.setAttribute('aria-hidden', 'true');
        prev.innerHTML = LOCKET_SVG_PHOTO;
        const cap = document.createElement('div');
        cap.className = 'locket-mono-style-tile__caption';
        let capText = displayChoiceTitle(subChoice.title);
        if (subChoice.price && parseFloat(subChoice.price) > 0) {
          capText += ` (+$${parseFloat(subChoice.price).toFixed(2)})`;
        }
        cap.textContent = capText;
        tile.appendChild(prev);
        tile.appendChild(cap);
        tile.addEventListener('click', () => {
          selected.sub = subIdx;
          selected.subChoice = subChoice;
          renderStep();
          updateNavButtons();
        });
        styleRow.appendChild(tile);
      });
      wrap.appendChild(styleRow);
      panel.appendChild(wrap);
    }

    function renderPanelContent(panel, choice) {
      panel.innerHTML = '';
      const selected = selections[step.key];
      if (!selected) return;

      const canonTitle = canonicalEngravingMainTitle(choice.title);

      let subOptions = [];
      let subTitle = '';
      if (canonTitle === 'Image') {
        subOptions = imageMethodOptions;
        subTitle = 'Choose insertion method:';
      } else if (canonTitle === 'Text') {
        subOptions = textFontOptions;
        subTitle = 'Choose style:';
      } else if (canonTitle === 'Monogram') {
        subOptions = monogramFontOptions;
        subTitle = 'Choose style:';
      }

      if (canonTitle === 'Image' && subOptions.length > 0) {
        renderImageMethodPanel(panel, subOptions, selected);
      } else if (canonTitle === 'Monogram' && subOptions.length > 0) {
        renderMonogramRichPanel(panel, subOptions, selected);
      } else if (subOptions.length > 0) {
        const subTitleEl = document.createElement('h4');
        subTitleEl.className = 'locket-sub-option-heading';
        subTitleEl.textContent = subTitle;
        panel.appendChild(subTitleEl);

        subOptions.forEach((subChoice, subIdx) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'locket-sub-option-btn';
          btn.textContent = subChoice.title;
          if (subChoice.price && parseFloat(subChoice.price) > 0) {
            btn.textContent += ` (+$${parseFloat(subChoice.price).toFixed(2)})`;
          }
          if (selected.sub === subIdx) btn.classList.add('active');
          btn.addEventListener('click', () => {
            selected.sub = subIdx;
            selected.subChoice = subChoice;
            renderStep();
            updateNavButtons();
          });
          panel.appendChild(btn);
        });
      }

      renderFields(panel, canonTitle);
      syncOverlay(canonTitle);
    }

    const cardRows = getEngravingCardRows(step);

    const photoIdxs = cardRows.filter(({ choice }) => canonicalEngravingMainTitle(choice.title) === 'Image');
    const textMonoIdxs = cardRows.filter(({ choice }) => {
      const c = canonicalEngravingMainTitle(choice.title);
      return c === 'Text' || c === 'Monogram';
    });
    const useTwoTierEngraving = photoIdxs.length >= 1 && textMonoIdxs.length >= 1;
    const useEngravingCards = cardRows.length >= 2;

    function appendDetailAndSkip(showSkip) {
      const detail = document.createElement('div');
      detail.className = 'locket-selector-detail';
      const selNow = selections[step.key];
      if (selNow && !selNow.skip && selNow.main !== undefined && selNow.choice) {
        renderPanelContent(detail, selNow.choice);
      }
      contentContainer.appendChild(detail);
      if (showSkip) {
        const skipBtn = document.createElement('button');
        skipBtn.type = 'button';
        skipBtn.className = 'locket-btn-skip';
        skipBtn.textContent = 'SKIP';
        skipBtn.addEventListener('click', () => {
          selections[step.key] = { skip: true };
          nextStep();
        });
        contentContainer.appendChild(skipBtn);
      }
    }

    if (useTwoTierEngraving) {
      const sel = selections[step.key];

      if (sel && sel.engravingPhase === 'text-pick') {
        const backBtn = document.createElement('button');
        backBtn.type = 'button';
        backBtn.className = 'locket-engraving-tier-back';
        backBtn.setAttribute('aria-label', 'Back to engraving options');
        backBtn.textContent = '← Back';
        backBtn.addEventListener('click', () => {
          delete selections[step.key];
          renderStep();
          updateNavButtons();
        });
        contentContainer.appendChild(backBtn);

        const stack = document.createElement('div');
        stack.className = 'locket-selectors-stack';

        textMonoIdxs.forEach(({ choice, idx }) => {
          const card = document.createElement('button');
          card.type = 'button';
          card.className = 'locket-selector-card locket-selector-card--style-pick';
          const isSelected = sel && !sel.skip && sel.main === idx;
          if (isSelected) card.classList.add('is-selected');

          const iconWrap = document.createElement('span');
          iconWrap.className = 'locket-selector-card__icon';
          iconWrap.setAttribute('aria-hidden', 'true');
          iconWrap.innerHTML = choiceIconSvgHtml(choice.title, 'style');

          const body = document.createElement('span');
          body.className = 'locket-selector-card__body';

          const headingRow = document.createElement('span');
          headingRow.className = 'locket-selector-card__heading-row';

          const titleBlock = document.createElement('span');
          titleBlock.className = 'locket-selector-card__title-block';
          const titleEl = document.createElement('span');
          titleEl.className = 'locket-selector-card__title';
          titleEl.textContent = stylePickerCardTitle(choice.title);

          titleBlock.appendChild(titleEl);

          const priceSpan = document.createElement('span');
          priceSpan.className = 'locket-selector-card__price';
          priceSpan.textContent = formatSelectorMainPrice(choice.price);

          headingRow.appendChild(titleBlock);
          headingRow.appendChild(priceSpan);

          const desc = document.createElement('p');
          desc.className = 'locket-selector-card__desc';
          const d = stylePickerCardDescription(choice.title);
          desc.textContent = d;
          desc.style.display = d ? '' : 'none';

          body.appendChild(headingRow);
          body.appendChild(desc);

          card.appendChild(iconWrap);
          card.appendChild(body);

          card.addEventListener('click', () => {
            const cur = selections[step.key];
            const same = cur && !cur.skip && cur.main === idx;
            if (same) {
              selections[step.key] = { engravingPhase: 'text-pick' };
              updateTextOverlay(step.key, '', false, 'Block');
            } else {
              selections[step.key] = { main: idx, choice, engravingPhase: 'text-pick' };
            }
            renderStep();
            updateNavButtons();
          });

          stack.appendChild(card);
        });

        contentContainer.appendChild(stack);
        appendDetailAndSkip(false);
      } else {
        const stack = document.createElement('div');
        stack.className = 'locket-selectors-stack';

        photoIdxs.forEach(({ choice, idx }) => {
          const card = document.createElement('button');
          card.type = 'button';
          card.className = 'locket-selector-card';
          const isSelected =
            sel &&
            !sel.skip &&
            sel.main === idx &&
            (!sel.engravingPhase || sel.engravingPhase === 'root');
          if (isSelected) card.classList.add('is-selected');

          const iconWrap = document.createElement('span');
          iconWrap.className = 'locket-selector-card__icon';
          iconWrap.setAttribute('aria-hidden', 'true');
          iconWrap.innerHTML = choiceIconSvgHtml(choice.title);

          const body = document.createElement('span');
          body.className = 'locket-selector-card__body';

          const headingRow = document.createElement('span');
          headingRow.className = 'locket-selector-card__heading-row';

          const titleBlock = document.createElement('span');
          titleBlock.className = 'locket-selector-card__title-block';
          const titleEl = document.createElement('span');
          titleEl.className = 'locket-selector-card__title';
          titleEl.textContent = rootPhotoCardTitle(choice.title);
          const badge = document.createElement('span');
          badge.className = 'locket-selector-card__badge';
          badge.textContent = choice.badge ? displayChoiceTitle(choice.badge) : 'Badge';
          titleBlock.appendChild(titleEl);
          titleBlock.appendChild(badge);

          const priceSpan = document.createElement('span');
          priceSpan.className = 'locket-selector-card__price';
          priceSpan.textContent = formatSelectorMainPrice(choice.price);

          headingRow.appendChild(titleBlock);
          headingRow.appendChild(priceSpan);

          const desc = document.createElement('p');
          desc.className = 'locket-selector-card__desc';
          desc.textContent = engravingSelectorDescription(choice.title);

          body.appendChild(headingRow);
          body.appendChild(desc);

          card.appendChild(iconWrap);
          card.appendChild(body);

          card.addEventListener('click', () => {
            const selNow = selections[step.key];
            const currentlyOpen =
              selNow &&
              !selNow.skip &&
              (!selNow.engravingPhase || selNow.engravingPhase === 'root') &&
              selNow.main === idx;
            if (currentlyOpen) {
              delete selections[step.key];
              updateTextOverlay(step.key, '', false, 'Block');
            } else {
              selections[step.key] = { main: idx, choice, engravingPhase: 'root' };
            }
            renderStep();
            updateNavButtons();
          });

          stack.appendChild(card);
        });

        const synCard = document.createElement('button');
        synCard.type = 'button';
        synCard.className = 'locket-selector-card';

        const synIcon = document.createElement('span');
        synIcon.className = 'locket-selector-card__icon';
        synIcon.setAttribute('aria-hidden', 'true');
        synIcon.innerHTML = choiceIconSvgHtml('', 'synthetic-text-root');

        const synBody = document.createElement('span');
        synBody.className = 'locket-selector-card__body';
        const synHead = document.createElement('span');
        synHead.className = 'locket-selector-card__heading-row';
        const synTitleBlock = document.createElement('span');
        synTitleBlock.className = 'locket-selector-card__title-block';
        const synTitle = document.createElement('span');
        synTitle.className = 'locket-selector-card__title';
        synTitle.textContent = 'Text Engraving';
        const synBadge = document.createElement('span');
        synBadge.className = 'locket-selector-card__badge';
        synBadge.textContent = 'Badge';
        synTitleBlock.appendChild(synTitle);
        synTitleBlock.appendChild(synBadge);
        const synPrice = document.createElement('span');
        synPrice.className = 'locket-selector-card__price';
        const maxTextMonoPrice = textMonoIdxs.reduce(
          (m, { choice: ch }) => Math.max(m, parseFloat(ch.price) || 0),
          0
        );
        synPrice.textContent = maxTextMonoPrice > 0 ? formatSelectorMainPrice(String(maxTextMonoPrice)) : '';
        synHead.appendChild(synTitleBlock);
        synHead.appendChild(synPrice);
        const synDesc = document.createElement('p');
        synDesc.className = 'locket-selector-card__desc';
        synDesc.textContent =
          'Add monogrammed initials, names, or a special message to make it truly personal.';
        synBody.appendChild(synHead);
        synBody.appendChild(synDesc);
        synCard.appendChild(synIcon);
        synCard.appendChild(synBody);
        synCard.addEventListener('click', () => {
          selections[step.key] = { engravingPhase: 'text-pick' };
          renderStep();
          updateNavButtons();
        });
        stack.appendChild(synCard);

        contentContainer.appendChild(stack);
        appendDetailAndSkip(true);
      }
    } else if (useEngravingCards) {
      const stack = document.createElement('div');
      stack.className = 'locket-selectors-stack';

      cardRows.forEach(({ choice, idx }) => {
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'locket-selector-card';
        const isSelected =
          selections[step.key] && !selections[step.key].skip && selections[step.key].main === idx;
        if (isSelected) card.classList.add('is-selected');

        const iconWrap = document.createElement('span');
        iconWrap.className = 'locket-selector-card__icon';
        iconWrap.setAttribute('aria-hidden', 'true');
        iconWrap.innerHTML = choiceIconSvgHtml(choice.title);

        const body = document.createElement('span');
        body.className = 'locket-selector-card__body';

        const headingRow = document.createElement('span');
        headingRow.className = 'locket-selector-card__heading-row';

        const titleBlock = document.createElement('span');
        titleBlock.className = 'locket-selector-card__title-block';
        const titleEl = document.createElement('span');
        titleEl.className = 'locket-selector-card__title';
        titleEl.textContent = rootPhotoCardTitle(choice.title);
        const badge = document.createElement('span');
        badge.className = 'locket-selector-card__badge';
        badge.textContent = choice.badge ? displayChoiceTitle(choice.badge) : 'Badge';
        titleBlock.appendChild(titleEl);
        titleBlock.appendChild(badge);

        const priceSpan = document.createElement('span');
        priceSpan.className = 'locket-selector-card__price';
        priceSpan.textContent = formatSelectorMainPrice(choice.price);

        headingRow.appendChild(titleBlock);
        headingRow.appendChild(priceSpan);

        const desc = document.createElement('p');
        desc.className = 'locket-selector-card__desc';
        desc.textContent = engravingSelectorDescription(choice.title);

        body.appendChild(headingRow);
        body.appendChild(desc);

        card.appendChild(iconWrap);
        card.appendChild(body);

        card.addEventListener('click', () => {
          const currentlyOpen =
            selections[step.key] && !selections[step.key].skip && selections[step.key].main === idx;
          if (currentlyOpen) {
            delete selections[step.key];
            updateTextOverlay(step.key, '', false, 'Block');
          } else {
            selections[step.key] = { main: idx, choice };
          }
          renderStep();
          updateNavButtons();
        });

        stack.appendChild(card);
      });

      contentContainer.appendChild(stack);
      appendDetailAndSkip(true);
    } else {
      mainOptions.forEach((choice, idx) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'locket-option-card';

        const header = document.createElement('button');
        header.type = 'button';
        header.className = 'locket-option-head';

        const left = document.createElement('span');
        const label = displayChoiceTitle(choice.title);
        left.textContent =
          label + (choice.price && parseFloat(choice.price) > 0 ? ` (+$${parseFloat(choice.price).toFixed(2)})` : '');
        const right = document.createElement('span');
        const isOpen = selections[step.key] && selections[step.key].main === idx;
        right.textContent = isOpen ? '−' : '+';
        right.className = 'locket-option-expand';
        header.appendChild(left);
        header.appendChild(right);

        const panel = document.createElement('div');
        panel.className = `locket-option-panel ${isOpen ? 'is-open' : ''}`;

        header.addEventListener('click', () => {
          const currentlyOpen = selections[step.key] && selections[step.key].main === idx;
          if (currentlyOpen) {
            delete selections[step.key];
            updateTextOverlay(step.key, '', false, 'Block');
          } else {
            selections[step.key] = { main: idx, choice };
          }
          renderStep();
          updateNavButtons();
        });

        if (isOpen) renderPanelContent(panel, choice);

        wrapper.appendChild(header);
        wrapper.appendChild(panel);
        contentContainer.appendChild(wrapper);
      });
    }
  }
  
  // Update navigation buttons
  function updateNavButtons() {
    const prevBtn = document.getElementById(`locket-prev-${sectionId}`);
    const nextBtn = document.getElementById(`locket-next-${sectionId}`);
    const addBtn = document.getElementById(`locket-add-cart-${sectionId}`);
    
    if (!prevBtn || !nextBtn || !addBtn || !customizerData) return;
    
    // Previous button
    prevBtn.disabled = currentStepIndex === 0;
    
    // Check if current step is valid
    const currentStep = customizerData.steps[currentStepIndex];
    const sel = selections[currentStep.key];
    const isCurrentStepValid = sel && (sel.skip === true || (sel.main !== undefined && selectionAllowsProceed(currentStep, sel)));
    
    // Next/Add to cart buttons
    const isLastStep = currentStepIndex === customizerData.steps.length - 1;
    
    if (isLastStep) {
      nextBtn.style.display = 'none';
      addBtn.style.display = 'block';
      addBtn.disabled = !isCurrentStepValid;
    } else {
      nextBtn.style.display = 'block';
      addBtn.style.display = 'none';
      nextBtn.disabled = !isCurrentStepValid;
      const nextStepTitle = customizerData.steps[currentStepIndex + 1]?.title || 'Next';
      nextBtn.textContent = `NEXT: ${nextStepTitle}`;
    }
    prevBtn.textContent = 'Back';
    updateStickyPrice();
  }

  function updateStickyPrice() {
    const priceEl = document.getElementById(`locket-price-${sectionId}`);
    if (!priceEl || !customizerData) return;
    const form = document.querySelector(`#product-form-${sectionId}`);
    const priceNode = form?.closest('.product__info-container')?.querySelector('.price-item--regular') || document.querySelector('.price-item--regular');
    let baseText = priceNode?.textContent?.trim() || '$0.00';
    let customTotal = 0;
    customizerData.steps.forEach((step) => {
      const selected = selections[step.key];
      if (!selected || selected.skip) return;
      customTotal += parseFloat(selected.choice?.price) || 0;
      customTotal += parseFloat(selected.subChoice?.price) || 0;
      if (selected.requestProof) customTotal += PHOTO_PROOF_PRICE;
    });
    if (customTotal > 0) {
      priceEl.textContent = `${baseText} + $${customTotal.toFixed(2)}`;
    } else {
      priceEl.textContent = baseText;
    }
  }
  
  // Navigate to previous step
  function prevStep() {
    if (currentStepIndex > 0) {
      currentStepIndex--;
      renderTabs();
      renderStep();
      updatePreviewImage();
      updateNavButtons();
    }
  }
  
  // Navigate to next step
  function nextStep() {
    const currentStep = customizerData.steps[currentStepIndex];
    const sel = selections[currentStep.key];
    if (!sel || (sel.skip !== true && (sel.main === undefined || !selectionAllowsProceed(currentStep, sel)))) {
      alert('Please complete this step (including any style or photo method options) before proceeding.');
      return;
    }
    
    if (currentStepIndex < customizerData.steps.length - 1) {
      currentStepIndex++;
      renderTabs();
      renderStep();
      updatePreviewImage();
      updateNavButtons();
    }
  }
  
  // Add to cart
  async function addToCart() {
    if (!customizerData) return;

    for (const st of customizerData.steps) {
      const s = selections[st.key];
      if (!selectionAllowsProceed(st, s)) {
        alert('Please finish each step (photo method, text style, etc.) before adding to cart.');
        return;
      }
    }
    
    // Calculate total customization price and build properties
    let totalCustomizationPrice = 0;
    const properties = {};
    
    customizerData.steps.forEach((step) => {
      if (selections[step.key] && !selections[step.key].skip && selections[step.key].choice) {
        const mainChoice = selections[step.key].choice;
        properties[`${step.title} - Option`] = mainChoice.title;
        
        // Add main choice price
        const mainPrice = parseFloat(mainChoice.price) || 0;
        totalCustomizationPrice += mainPrice;
        
        // Add sub-choice if exists
        if (selections[step.key].subChoice) {
          const subChoice = selections[step.key].subChoice;
          properties[`${step.title} - ${mainChoice.title} Style`] = subChoice.title;
          
          // Add sub-choice price
          const subPrice = parseFloat(subChoice.price) || 0;
          totalCustomizationPrice += subPrice;
        }
        
        // Add personalization data (text inputs, file uploads)
        if (selections[step.key].personalization) {
          Object.keys(selections[step.key].personalization).forEach(fieldName => {
            const value = selections[step.key].personalization[fieldName];
            if (value && value.trim() !== '') {
              properties[`${step.title} - ${fieldName}`] = value;
            }
          });
        }

        // §12 photo extras: B&W, design note, request proof (+$10)
        if (selections[step.key].photoBW) {
          properties[`${step.title} - Photo`] = 'Black & White';
        }
        const note = selections[step.key].designNote;
        if (note && note.trim() !== '') {
          properties[`${step.title} - Design Note`] = note.trim();
        }
        if (selections[step.key].requestProof) {
          properties[`${step.title} - Proof Requested`] = `Yes (+$${PHOTO_PROOF_PRICE})`;
          totalCustomizationPrice += PHOTO_PROOF_PRICE;
        }
      }
    });
    
    // Add total customization price to properties
    if (totalCustomizationPrice > 0) {
      properties['_Customization Fee'] = `$${totalCustomizationPrice.toFixed(2)}`;
      properties['_Customization Total'] = totalCustomizationPrice * 100; // In cents for calculations
    }
    
    // Get product ID and variant
    const productId = customizerData.product_id;
    const form = document.querySelector(`#product-form-${sectionId}`);
    const variantInput = form?.querySelector('[name="id"]');
    const variantId = variantInput?.value;
    
    if (!variantId) {
      alert('Please select a product variant.');
      return;
    }
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: properties,
        }),
      });
      
      if (response.ok) {
        forceCloseCustomizer();
        // Trigger cart update event
        document.dispatchEvent(new CustomEvent('cart:updated'));
        // Optionally redirect to cart
        window.location.href = '/cart';
      } else {
        const error = await response.json();
        alert(`Error adding to cart: ${error.description || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('Failed to add to cart:', err);
      alert('Failed to add to cart. Please try again.');
    }
  }

  /** Step header / footer Back: leave inner engraving flow before previous wizard step */
  function handleCustomizerBack() {
    if (!customizerData) {
      prevStep();
      return;
    }
    const step = customizerData.steps[currentStepIndex];
    if (!step) {
      prevStep();
      return;
    }
    const sel = selections[step.key];
    if (isTwoTierEngravingStep(step) && sel && sel.engravingPhase === 'text-pick') {
      if (sel.main !== undefined) {
        selections[step.key] = { engravingPhase: 'text-pick' };
        updateTextOverlay(step.key, '', false, 'Block');
        renderTabs();
        renderStep();
        updatePreviewImage();
        updateNavButtons();
        return;
      }
      delete selections[step.key];
      updateTextOverlay(step.key, '', false, 'Block');
      renderTabs();
      renderStep();
      updatePreviewImage();
      updateNavButtons();
      return;
    }
    prevStep();
  }
  
  // Initialize - wait for both DOM and defer scripts
  function initialize() {
    const customizeBtns = document.querySelectorAll('.locket-start-customize-btn');
    
    customizeBtns.forEach((customizeBtn) => {
      customizeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        sectionId = customizeBtn.dataset.sectionId || '';
        
        if (!sectionId) {
          alert('Error: No section ID found');
          return;
        }
        
        openCustomizer();
      });
    });
    
    // Initialize event listeners for modal (delegated)
    document.addEventListener('click', (e) => {
      const exitRoot = e.target.closest('.locket-exit-confirm');
      if (exitRoot) {
        const sid = exitRoot.dataset.sectionId;
        if (!sid) return;
        if (e.target.closest('.locket-exit-confirm__primary')) {
          e.preventDefault();
          e.stopPropagation();
          withSection(sid, forceCloseCustomizer);
          return;
        }
        if (
          e.target.closest('.locket-exit-confirm__secondary') ||
          e.target.closest('.locket-exit-confirm__x') ||
          e.target.classList.contains('locket-exit-confirm__backdrop')
        ) {
          e.preventDefault();
          e.stopPropagation();
          hideExitConfirm(sid);
          return;
        }
        if (e.target.closest('.locket-exit-confirm__modal')) {
          e.stopPropagation();
        }
        return;
      }

      // Close button
      if (e.target.closest('.locket-customizer-close')) {
        e.preventDefault();
        e.stopPropagation();
        requestCloseCustomizer();
      }
      
      // Overlay click to close
      if (e.target.classList.contains('locket-customizer-overlay')) {
        requestCloseCustomizer();
      }
      
      // Navigation buttons
      if (e.target.closest('[id^="locket-prev-"]')) {
        e.preventDefault();
        handleCustomizerBack();
      }
      if (e.target.closest('[id^="locket-step-back-"]')) {
        e.preventDefault();
        handleCustomizerBack();
      }
      
      if (e.target.closest('[id^="locket-next-"]')) {
        e.preventDefault();
        nextStep();
      }
      
      if (e.target.closest('[id^="locket-add-cart-"]')) {
        e.preventDefault();
        addToCart();
      }
    });
    
  }
  
  // Run initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
